import { Component, ViewEncapsulation, OnInit } from '@angular/core';
declare var $: any; 
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AppComponent implements OnInit{
  isJqueryWorking: any; 
  ngOnInit(): void {   
  }
  title = 'MyNewProject';
}
